import { useCallback } from 'react';
import { CoreDomainSearchStore, DomainSearchSuiteModule } from '@wix/domains-search-suite';
import { useQueryParams } from './useQueryParams';
import { useViewTransition } from './useViewTransition';
import { GatePath } from '../Pages/types';
import { SEARCH_QUERY_PARAMS } from '../constants';
export const useResultsBack = function (_temp) {
  let _ref = _temp === void 0 ? {} : _temp,
    _ref$toGate = _ref.toGate,
    toGate = _ref$toGate === void 0 ? false : _ref$toGate;
  const _useViewTransition = useViewTransition(),
    navigateBack = _useViewTransition.navigateBack,
    navigateTo = _useViewTransition.navigateTo;
  const _useQueryParams = useQueryParams(),
    search = _useQueryParams.search;
  return useCallback(() => {
    DomainSearchSuiteModule.internals.bi.onCTAClick == null || DomainSearchSuiteModule.internals.bi.onCTAClick({
      ctaClick: 'back_button'
    });
    if (toGate) {
      const params = new URLSearchParams(search);
      SEARCH_QUERY_PARAMS.forEach(param => params.delete(param));
      const nextSearch = params.toString();
      navigateTo(nextSearch ? `${GatePath.GATE}?${nextSearch}` : GatePath.GATE);
    } else {
      navigateBack();
    }
    setTimeout(() => {
      CoreDomainSearchStore.resetStore();
    });
  }, [navigateBack, navigateTo, search, toGate]);
};
//# sourceMappingURL=useResultsBack.js.map